import { Container } from "@/components/container";

export default function DevOps() {
  return (
    <div>
      <section className="bg-secondary/50 border-b">
        <Container className="py-12 md:py-16">
          <h1 className="text-3xl md:text-4xl font-semibold">DevOps & Automation</h1>
          <p className="mt-3 text-muted-foreground max-w-2xl">
            CI/CD pipelines, Infrastructure as Code, and observability to ship faster with
            confidence.
          </p>
        </Container>
      </section>
      <Container className="py-12 md:py-16 grid gap-10 md:grid-cols-3">
        <div className="md:col-span-2 space-y-6">
          <Section title="The problem">
            Manual deploys, inconsistent environments, and limited visibility cause outages and slow
            delivery.
          </Section>
          <Section title="Our solution">
            Standardized pipelines, IaC (Terraform), containerization, and dashboards with alerts
            and SLOs.
          </Section>
          <Section title="Expected outcomes">
            • Faster releases • Fewer incidents • Reproducible infra • Actionable insights
          </Section>
        </div>
        <aside className="space-y-4">
          <h3 className="font-semibold">Deliverables</h3>
          <ul className="text-sm text-muted-foreground space-y-2 list-disc pl-5">
            <li>CI/CD pipelines and templates</li>
            <li>IaC repositories (Terraform)</li>
            <li>Observability stack (logs, metrics, traces)</li>
            <li>SLOs and alerting policy</li>
            <li>Runbooks and handover</li>
          </ul>
        </aside>
      </Container>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold">{title}</h2>
      <p className="text-muted-foreground leading-relaxed">{children}</p>
    </div>
  );
}
